<acv-grid-count-dialog #ACV_GridCountDialog_Ref (Submit_Clicked)="onReload.emit($event)" (onPodClick)="onPodClickGrid.emit($event)"></acv-grid-count-dialog>

<div class="grid_parent">
    <!-- <div class="grid_wrapper" [ngClass]="grid_columns?.length > 5 ? 'acv-grid-scroll' : 'acv-grid-fixedcol'"></div> -->
    <div class="grid_wrapper">
        <p-table #DigicomGrid [columns]="grid_columns" [resizableColumns]="true"
            [value]="grid_data" [scrollable]="true" [lazy]="true" sortMode="single"
            [sortField]="sortField"
            [sortOrder]="sortOrder"
            [dataKey]="getRowExpansionKeyField()"
            [expandedRowKeys]="expandedRowKeys"
            [reorderableColumns]="allow_columnReOrder" [scrollHeight]="'100%'" [(selection)]="selectedRecords"
            (onHeaderCheckboxToggle)="onSelectAll($event)" (selectionChange)="onSelectionChange($event)"
            (onSort)="onSortChange($event)"
            (onRowExpand)="onRowExpand($event)"
            (onRowCollapse)="onRowCollapse($event)">
            <ng-template pTemplate="header" let-columns>
                <tr>
                    <th *ngIf="allow_selection" style="width: 5% !important" class="text-center">
                        <p-tableHeaderCheckbox *ngIf="allow_Headerselection"></p-tableHeaderCheckbox>
                    </th>
                    <th *ngIf="rowExpansion" style="width: 2.5rem"></th>
                    <ng-container *ngFor="let col of columns">

            <th *ngIf="allow_columnReOrder" [pSortableColumn]="(allow_sorting && !hold_gridSorting) ? col.field : ''"
              pReorderableColumn pResizableColumn [ngClass]="col.styleClass ? col.styleClass : ''"
              [class.hold-gridSorting]="hold_gridSorting"
              [ngStyle]="{'text-align':'left', 'width': col.colWidth ? col.colWidth : null}">
              {{col.header}}
              <p-sortIcon *ngIf="allow_sorting && col.header && !hold_gridSorting" field="{{col.field}}"></p-sortIcon>
            </th>

            <th *ngIf="!allow_columnReOrder" [pSortableColumn]="(allow_sorting && !hold_gridSorting) ? col.field : ''"
              pResizableColumn [ngClass]="col.styleClass ? col.styleClass : ''"
              [ngStyle]="{'text-align': 'left', 'width': col.colWidth ? col.colWidth : null}">
              {{col.header}}<p-sortIcon *ngIf="allow_sorting && !hold_gridSorting" field="{{col.field}}"></p-sortIcon>
            </th>
          </ng-container>

          <ng-container *ngIf="!freeze_actionColumn">
            <th class="text-center action-th" style="width: 1rem" *ngIf="show_livelevelActions">
              <i class="pi i-reorder" *ngIf="reorderableColumns" (click)="columnReorderToggle()"></i>
            </th>
          </ng-container>
          <ng-container *ngIf="show_EditIcon || show_DeleteIcon || show_AttachmentIcon">
            <th class="text-center px-5" style="width: 1rem">
            </th>
          </ng-container>
        </tr>
      </ng-template>

      <ng-template pTemplate="groupheader" let-data *ngIf="show_RowGroup">
        <tr pRowGroupHeader>
          <td [attr.colspan]="getGridColspan()">
            <span class="font-bold ml-2">{{ data.row_group }}</span>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded">
        <tr [ngClass]="{'flag-blue-row':rowData.is_active === 1 && rowData.hasOwnProperty('last_action_flag')}">
          <td *ngIf="allow_selection" class="text-center selection-cell ">
            <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
            <div *ngIf="shouldShowBlinkingDot(rowData)"
            class="blinking-green-dot"
            [ngClass]="{'blink-animation': isBlinking(rowData)}">
       </div>
          </td>
          <td *ngIf="rowExpansion" class="text-center" style="width: 2.5rem">
            <button type="button"
              pButton
              pRipple
              [pRowToggler]="rowData"
              class="acv-expander-btn p-button-text p-button-plain"
              [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'">
            </button>
          </td>

          <ng-container *ngFor="let col of columns">
            <ng-container *ngIf="
                col.field == 'status' || col.field == 'due_at' || col.field == 'is_active' || col.field == 'sorted_status' ;
                else noStatusCol
              ">
              <td [attr.status]="rowData['order_type']" [ngClass]="{
                  'active-button':
                    rowData[col.field]?.toLowerCase() == 'active' ||
                    rowData[col.field] == true,
                  'inactive-button':
                    rowData[col.field]?.toLowerCase() == 'inactive' ||
                    rowData[col.field] == false
                }" [ngStyle]="{ 'text-align': col.align }" style="width: 100px;">
                <div class="flex flex-row">
                  <button style="cursor: default; margin-left: 12px; margin-right: 12px;" pButton [attr.status]="rowData[col.field]" type="button" label="{{
                      col.field == 'is_active'
                        ? rowData[col.field]?.toLowerCase() == 'active' ||
                          rowData[col.field] == true
                          ? 'Active'
                          : 'Inactive'
                        : rowData[col.field]
                        ? rowData[col.field]
                        : '-'
                    }}" class="btn-status p-button-outlined"></button>
                </div>
              </td>
            </ng-container>

            <ng-template #noStatusCol>
              <ng-container *ngIf="col.fieldType == 'input'; else dateCol">
                <td [ngStyle]="{ 'text-align': col.align }">
                  <input type="text" [ngClass]="col.inputStyleClass ? col.inputStyleClass : ''" pInputText
                    [(ngModel)]="rowData[col.field]" placeholder="-" />
                </td>
              </ng-container>
              <ng-template #dateCol>
                <ng-container *ngIf="col.fieldType == 'checkbox'; else checkDateCol">
                  <td [ngStyle]="{ 'text-align': col.align }">
                    <div class="flex gap-2" [ngClass]="
                        col.align == 'center'
                          ? 'justify-content-center'
                          : 'justify-content-start pl-3 pr-3'">
                      <p-checkbox [binary]="true"
                        [(ngModel)]="rowData[col.field]"
                        (onChange)="onGridAction('CheckboxChange', {row: rowData, field: col.field, value: rowData[col.field]})">
                      </p-checkbox>
                    </div>
                  </td>
                </ng-container>
                <ng-template #checkDateCol>
                <ng-container *ngIf="col.fieldType == 'date'; else noInputCol">
                  <td [ngStyle]="{ 'text-align': col.align }">
                    <div class="flex gap-2" [ngClass]="
                        col.align == 'center'
                          ? 'justify-content-center'
                          : 'justify-content-start pl-3 pr-3'">
                      <p [(ngModel)]="rowData[col.field]" placeholder="-" [name]="rowData[col.field]" ngDefaultControl>
                        {{
                        rowData[col.field]
                        ? (rowData[col.field] | date : col.format)
                        : "-"
                        }}
                      </p>
                    </div>

                    <!-- <div class="flex gap-2" [ngClass]="col.align == 'center' ? 'justify-content-center' : 'justify-content-start'">
                                            <p [pTooltip]=" rowData[col.field]?.length > 15 ? (rowData[col.field] | date : col.format) : ''"
                                                tooltipPosition="right" [ngClass]="col.isClickable == true ? 'cursor-pointer' : ''">
                                                {{
                                                (rowData[col.field] || rowData[col.field] === 0) ?
                                                (rowData[col.field].length > 15 ? ((rowData[col.field] | date : col.format) | slice:0:15)
                                                :
                                                (rowData[col.field] | date : col.format)) : '-'
                                                }}
                                            </p>
                                            <p style="color: #96444B; letter-spacing: 1px;" class="fw-500 fs-15"
                                                *ngIf="rowData[col.field]?.length > 15"
                                                [pTooltip]="rowData[col.field] | date : col.format" tooltipPosition="right">
                                                ...
                                            </p>
                                        </div> -->
                  </td>
                </ng-container>
                </ng-template>
              </ng-template>
              <ng-template #noInputCol>
                <ng-container *ngIf="allowHighlightSearching; else nohighlightSearching">
                  <td [ngStyle]="{
                      'text-align': col.align,
                      'text-decoration': col.externalLink && 'underline'
                    }" (click)="
                      (col.isClickable || col.externalLink) &&
                        oncellClicked(rowData)
                    " [ngClass]="[col.classList ? col.classList : '']">
                    <p [style]="{
                        'text-transform': col.capitalize ? 'capitalize' : '',
                        cursor:
                          (col.isClickable || col.externalLink) && 'pointer'
                      }" [ngClass]="
                        col.allowHiglight &&
                        rowData['is_failed'] &&
                        rowData['failed_field'] == col.field
                          ? 'highlight_text'
                          : ''
                      " [innerHtml]="
                        rowData[col.field] || rowData[col.field] == 0
                          ? (rowData[col.field]
                            | highlighter : highlightedSearchItems : 'full')
                          : '-'
                      ">
                      <i *ngIf="col.externalLink" class="pi i-arrow-topR" style="cursor: pointer"></i>
                    </p>
                  </td>
                </ng-container>
                <ng-template #nohighlightSearching>
                  <td [ngStyle]="{
                      'text-align': col.align,
                      'text-decoration': col.externalLink && 'underline'
                    }" (click)="
                      (col.isClickable || col.externalLink) &&
                        oncellClicked(rowData)
                    " [ngClass]="[col.classList ? col.classList : '']">
                    <ng-container *ngIf="col?.isView">
                      <div class="flex align-items-center gap-2 pl-2">
                        <p (click)="rowData[col.field] && onViewClick(col, rowData[col?.field], rowData)" [style]="{
                            'font-size': '12px',
                            'text-decoration': rowData[col.field] ? 'underline' : 'none',
                            cursor: rowData[col.field] ? 'pointer' : 'cursor'
                          }">{{
                          rowData[col.field]
                            ? "View"
                            : '-'
                          }}
                        </p>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="col?.colEditable">
                      <ng-container>
                        <div class="flex justify-evenly align-items-center gap-2 pl-2 pr-2">
                          <p >
                            {{
                              rowData[col.field]
                              ? (rowData[col.field] | date : col.format)
                              : "-"
                            }}
                          </p>
                          <span class="cursor-pointer">
                            <img src="../../../assets/images/edit-pencil.svg" style="width: 11px; height: 11px"
                            alt="edit" (click)="editDialogEmit(rowData, col?.header)" />
                        </span>
                        </div>
                      </ng-container>
                    </ng-container>

                      <!-- <div class="flex justify-evenly align-items-center">
                        <p class="fs-14 fw-500 font-poppin text-color-black2 mt-2">{{detail_data?.detail[selectedTabIndex].actual_started_at ? (detail_data?.detail[selectedTabIndex].actual_started_at | date: 'MM/dd/yyyy HH:mm') : '-'}}</p>
                        (click)="editDialogEmit(rowData[col.field])"
                    </div> -->


                    <ng-container *ngIf="col?.colCount">
                      <ng-container *ngIf="rowData[col.field] && rowData[col.field].length">
                        <div class="flex align-items-center gap-2 pl-2 pr-2">
                          <p (click)="onCountClick(col, rowData)" [style]="{
                              'font-size': '12px',
                              'text-decoration': 'underline',
                              cursor: 'pointer'
                            }">
                            {{
                            col?.header === "Action"
                            ? rowData["action_count"].toString()
                            : rowData[col.field].length.toString()
                            }}
                          </p>
                          <!-- <p>{{rowData[col.field][0] | slice:0:4 }}</p>
                                                    <p style="color: #96444B; letter-spacing: 1px;" class="fw-500 fs-15"
                                                        >...</p>
                                                    <p-tag icon="pi ic-plus"
                                                        [ngClass]="{'small-font': (rowData[col.field].length - 1).toString().length>1}"
                                                        [rounded]="true"
                                                        (click)="onCountClick(col.field, rowData)"
                                                        [value]="(rowData[col.field].length - 1).toString()"></p-tag> -->
                        </div>
                      </ng-container>

                      <div class="pl-2 pr-2" *ngIf="!rowData[col.field] || rowData[col.field].length == 0">
                        <p>-</p>
                      </div>
                    </ng-container>

                    <ng-container *ngIf="col?.progressbar">
                      <div class="progress-wrapper">
                        <round-progress [current]="rowData[col.field]" [max]="100" [color]="
                            rowData[col.field] > 0 && rowData[col.field] < 100
                              ? '#F2D32E'
                              : '#35B109'
                          " [background]="'#eaeaea'" [radius]="22" [stroke]="6" [semicircle]="false" [rounded]="false"
                          [clockwise]="false" [responsive]="false" [duration]="600" [animation]="'easeInOutQuart'"
                          [animationDelay]="500"></round-progress>
                        <div class="progress-value">
                          {{ rowData[col.field] ? rowData[col.field] : "0" }}%
                        </div>
                      </div>
                    </ng-container>

                    <ng-container *ngIf="col?.colBoolean">
                      <div class="flex gap-2" [ngClass]="
                          col.align == 'center'
                            ? 'justify-content-center'
                            : 'justify-content-start pl-2 pr-2'">
                        <p [ngClass]="
                            col.isClickable == true ? 'cursor-pointer' : ''
                          ">
                          {{ rowData[col.field] === null || rowData[col.field] === undefined
                            ? '-'
                            : (rowData[col.field] === true || rowData[col.field] == 1 ? 'Yes' : 'No')
                        }}
                        </p>
                      </div>
                    </ng-container>

                    <ng-container *ngIf="col?.colClickableAction">
                      <ng-container *ngIf="rowData[col.field] !== null && rowData[col.field] !== undefined">
                        <div class="flex align-items-center gap-2 pl-2 pr-2">
                          <p (click)="onClickableActionClick(col, rowData)"
                             [style]="{
                               'cursor': 'pointer',
                               'text-decoration': 'underline'
                             }"
                             [ngClass]="col.clickableClass || ''"
                             [pTooltip]="shouldShowTooltip(col.valueGetter ? col.valueGetter(rowData) : rowData[col.field], col, rowData) ? getTooltipContent(col.valueGetter ? col.valueGetter(rowData) : rowData[col.field], col, rowData) : ''"
                             [tooltipPosition]="col.tooltipPosition || 'top'"
                             [tooltipStyleClass]="'acv-grid-tooltip ' + (col.tooltipClass || '')">
                             {{ rowData[col.field] ?? '-' }}
                          </p>
                        </div>
                      </ng-container>

                      <div class="pl-2 pr-2" *ngIf="rowData[col.field] === null || rowData[col.field] === undefined">
                        <p>-</p>
                      </div>
                    </ng-container>


                    <!-- for the trucate text -->
                    <ng-container *ngIf="col.truncate">
                      <p
                        class="truncate"
                        [ngStyle]="{'text-align': col.align, 'width': col.colWidth || 'auto'}">
                        {{rowData[col.field]}}
                      </p>
                    </ng-container>
                    <!-- remaining fallback columns -->
                    <ng-container *ngIf="!col?.colCount && !col?.progressbar && !col.colEditable && !col?.colBoolean && !col.truncate && !col?.colClickableAction">
                      <div class="flex gap-2" [ngClass]="
                          col.align == 'center'
                            ? 'justify-content-center'
                            : 'justify-content-start pl-2 pr-2'">
                        <p [ngClass]="
                            col.isClickable == true ? 'cursor-pointer' : ''
                          ">
                          {{
                            col.valueGetter
                              ? col.valueGetter(rowData)
                              : ( (rowData[col.field] || rowData[col.field] === 0) && !col?.isView
                                  ? rowData[col.field]
                                  : col?.isView ? '' : '-' )
                          }}
                        </p>
                        <!-- <p [pTooltip]=" rowData[col.field]?.length > 20 ? rowData[col.field] : ''"
                                                    tooltipPosition="right" [ngClass]="col.isClickable == true ? 'cursor-pointer' : ''">
                                                    {{
                                                    (rowData[col.field] || rowData[col.field] === 0) ?
                                                    (rowData[col.field].length > 15 ? (rowData[col.field] | slice:0:15)
                                                    :
                                                    rowData[col.field]) : '-'
                                                    }}
                                                </p>
                                                <p style="color: #96444B; letter-spacing: 1px;" class="fw-500 fs-15"
                                                    *ngIf="rowData[col.field]?.length > 20"
                                                    [pTooltip]="rowData[col.field]" tooltipPosition="right">
                                                    ...
                                                </p> -->
                      </div>
                    </ng-container>
                  </td>
                </ng-template>
              </ng-template>
            </ng-template>
          </ng-container>

          <ng-container *ngIf="freeze_actionColumn">
            <td class="text-center frozen-column" *ngIf="show_livelevelActions || show_EditIcon || show_DeleteIcon"
              alignFrozen="right" pFrozenColumn>
              <div class="grid_actions">
                <ng-container *ngTemplateOutlet="actionContent"></ng-container>
              </div>
            </td>
          </ng-container>

          <ng-container *ngIf="!freeze_actionColumn">
            <td [ngStyle]="show_livelevelActions ? { 'min-width': '3rem' } : { 'width': '2rem' }" *ngIf="show_livelevelActions || show_EditIcon">
              <div class="grid_actions" [ngStyle]="show_livelevelActions ? { 'position': 'absolute', 'top': '0%' } : null">
                <ng-container *ngTemplateOutlet="actionContent"></ng-container>
              </div>
            </td>
          </ng-container>

          <ng-template #actionContent>
            <!-- <ng-container *ngIf="show_livelevelActions">
                            <p-splitButton appendTo="body" [model]="line_levelActions" menuStyleClass="grid-actionMenu"
                                styleClass="p-button-text btn-action"></p-splitButton>
                        </ng-container> -->

            <ng-container *ngIf="show_livelevelActions && line_levelActions.length">
              <!-- <p-dropdown #actionDropdown [options]="getLineActionItems(rowData)" [appendTo]="'body'" [autoDisplayFirst]="false"
                                optionLabel="label" styleClass="p-button-text btn-action"
                                (onChange)="onLineAction($event, rowData); actionDropdown.updateSelectedOption(null)" [showClear]="false" placeholder=""
                                [panelStyleClass]="'grid-action-panel'"
                                [overlayOptions]="{styleClass: 'gridoverlay-content-panel'}">
                                <ng-template pTemplate="selectedItem"></ng-template>
                                <ng-template let-action pTemplate="item">
                                    <ng-container
                                        *ngIf="action?.label.toLowerCase() == 'active' || action?.label.toLowerCase() == 'inactive'; else nonstatus">
                                        <div>{{ (rowData.status == 'active' || rowData.status == 'Active' ||
                                            rowData?.is_active) ? 'Inactive' : 'Active' }}</div>
                                    </ng-container>
                                    <ng-template #nonstatus>
                                        <div>{{ action?.label }}</div>
                                    </ng-template>
                                </ng-template>
                            </p-dropdown> -->
              <!-- <p-splitButton [disabled]="rowData?.status === 'Completed'" appendTo="body"
                [model]="getLineActionItems(rowData)" menuStyleClass="grid-actionMenu"
                styleClass="p-button-text btn-action" (onDropdownClick)="active_row_data = rowData"
                [panelStyleClass]="'grid-action-panel'" [overlayOptions]="{ styleClass: 'gridoverlay-content-panel' }">
              </p-splitButton> -->
              <grid-action-button [disabled]="module_name === 'TripRequest' ? false : (module_name === 'Leads' &&rowData?.status === 'Completed')?false :(module_name === 'Rejected Lead')?true : (rowData?.status === 'Completed' ? true : false)"
              [data]="rowData" [items]="getLineActionItems(rowData)" (OnSelect)="onLineAction($event, null)" (OnButtonClick)="active_row_data = rowData"></grid-action-button>
            </ng-container>

            <ng-container *ngIf="show_EditIcon">
              <i class="pi i-Edit ml-3 mr-3" (click)="onGridAction('Edit', rowData)"></i>
            </ng-container>

            <ng-container *ngIf="show_DeleteIcon">
              <i class="pi i-trash-bin" (click)="onGridAction('Delete', rowData)"></i>
            </ng-container>

            <ng-container *ngIf="show_PodIcon && !!rowData.is_captured_pod">
              <i class="pi pi-external-link text-lg"
                (click)="rowData.is_captured_pod ? onGridAction('Pod', rowData) : null"></i>
            </ng-container>

            <ng-container *ngIf="show_AttachmentIcon">
              <i class="pi i-attachment" (click)="onGridAction('Edit', rowData)"></i>
            </ng-container>
          </ng-template>
        </tr>
      </ng-template>

      <ng-template pTemplate="rowexpansion" let-rowData>
        <tr>
          <td [attr.colspan]="getGridColspan()" class="p-2 acv-rowexpansion-cell" [ngClass]="{'acv-rowexpansion-cell--active': rowData.is_active === 1 && rowData.hasOwnProperty('last_action_flag')}">
            <div class="acv-row-expansion" [ngClass]="{'acv-row-expansion--active': rowData.is_active === 1 && rowData.hasOwnProperty('last_action_flag')}">
              <p-table
                [value]="getRowExpansionRows(rowData)"
                [columns]="getRowExpansionColumns()"
                [scrollable]="true"
                [rowHover]="true"
                scrollHeight="240px"
                styleClass="acv-nested-table p-datatable-sm p-datatable-gridlines">
                <ng-template pTemplate="header" let-columns>
                  <tr>
                    <th *ngFor="let col of columns" [ngStyle]="{'text-align': col.align || 'left', 'width': col.colWidth ? col.colWidth : null}">
                      {{ col.header }}
                    </th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-leg let-columns="columns">
                  <tr [ngClass]="getRowExpansionRowClass(leg, rowData)">
                    <td *ngFor="let col of columns" [ngStyle]="{'text-align': col.align || 'left'}">
                      <ng-container *ngIf="col.fieldType == 'date'; else nestedText">
                        {{ leg[col.field] ? (leg[col.field] | date : (col.format || 'dd-MMM-yy h:mm a')) : '-' }}
                      </ng-container>
                      <ng-template #nestedText>
                        {{ (leg[col.field] || leg[col.field] === 0) ? leg[col.field] : '-' }}
                      </ng-template>
                    </td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                  <tr>
                    <td [attr.colspan]="getRowExpansionColumns().length" class="text-center p-3">
                      {{ rowExpansion?.emptyMessage || 'No records found.' }}
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="getGridColspan()" class="text-center p-3">
            No records found.
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

    <div class="pagination_wrapper flex align-items-center  justify-content-between" *ngIf="allow_Pagination">
        <div class="left flex align-items-center pl-3">
            <p>No. of entries</p>
            <p-paginator [showCurrentPageReport]="false" [rows]="evenrows" [totalRecords]="totalRecords"
                [rowsPerPageOptions]="[50, 100, 150, 200, 250]" (onPageChange)="onPageSizeChange($event)"
                #p></p-paginator>
        </div>
        <div class="middle">
            <p class="fs-14 fw-400 font-poppin" style="margin-left: -8vw;">Showing {{currentPageReport?.first === null ?
                0 : currentPageReport?.first}} - {{currentPageReport?.last === null ? 0 : currentPageReport?.last}} of
                {{totalRecords}} entries</p>
        </div>
        <div class="right flex align-items-center">
            <p>Page {{firstPage}} of {{lastPage}}</p>
            <p-paginator [showCurrentPageReport]="false" [rows]="evenrows"
                [totalRecords]="lastPage == 1 ? 0 : totalRecords"
                [rowsPerPageOptions]="[50, 100, 150, 200, 250]" (onPageChange)="onPageChange($event)"
                #p></p-paginator>
        </div>

    </div>
</div>
